import { PatientControllerApi } from "../../services";
import { useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientValidateByDob = () =>
  useMutationWithLoading(
    async (params: { patientId: string; dob: string; xTENANTID?: string }) =>
      new PatientControllerApi().validatePatientDob(
        params?.patientId,
        params?.dob,
        params?.xTENANTID
      )
  );
